export const pageTitles = [
  { targetPath: "/admin/dashboard", title: "Dashboard" },
  { targetPath: "/admin/members", title: "Members" },
  { targetPath: "/admin/consultation", title: "Consultation" },
  { targetPath: "/admin/members/detail/", title: "Member Detail" },
  { targetPath: "/admin/coach", title: "Coach" },
  { targetPath: "/admin/workoutplans", title: "Workout Plans" },
  { targetPath: "/admin/exercise", title: "Exercises" },
  { targetPath: "/admin/refund-request", title: "Refund" },
  { targetPath: "/admin/wallet-request", title: "Request" },
  { targetPath: "/admin/saleTaxes", title: "System Settings" },
  { targetPath: "/admin/tax-group", title: "System Settings" },
  { targetPath: "/admin/incomeCategory", title: "System Settings" },
  { targetPath: "/admin/memberships", title: "System Settings" },
  { targetPath: "/admin/credits", title: "System Settings" },
  { targetPath: "/admin/roles", title: "System Settings" },
  { targetPath: "/admin/counter", title: "System Settings" },
  { targetPath: "/admin/categories", title: "System Settings" },
  { targetPath: "/admin/paymentMethods", title: "System Settings" },
  { targetPath: "/admin/system_configuration", title: "System Settings" },
  {
    targetPath: "/admin/hardware_integration",
    title: "System Settings",
  },
  { targetPath: "/admin/products", title: "System Settings" },
  { targetPath: "/admin/business-unit", title: "System Settings" },
  { targetPath: "/admin/pos/sell/", title: "Point of Sale" },
  { targetPath: "/admin/pos/register", title: "Point of Sale" },
  { targetPath: "/admin/pos/salesReport", title: "Point of Sale" },
  { targetPath: "/admin/pos/cash", title: "Point of Sale" },
  { targetPath: "/admin/staff", title: "Staff" },
  { targetPath: "/admin/mealplans", title: "Meal Plans" },
  { targetPath: "/admin/foods", title: "Food & Nutritions" },
  { targetPath: "/admin/finances", title: "Financials" },
  { targetPath: "/admin/check-in-logs", title: "Check In Details" },
  {
    targetPath: "/admin/members/detail",
    title: "Members",
  },
  { targetPath: "/admin/facility", title: "Facility Management" },
  { targetPath: "/admin/facility/schedule", title: "Facility Management" },
  { targetPath: "/admin/facility/booking", title: "Facility Management" },
  { targetPath: "/admin/facility/addon-returns", title: "Facility Management" },
  {
    targetPath: "/admin/facility/booking-management",
    title: "Facility Management",
  },
  {
    targetPath: "/admin/dh-accounting",
    title: "DH Accounting",
  },
  {
    targetPath: "/admin/event",
    title: "Events",
  },
  {
    targetPath: "/admin/report/sales",
    title: "Report Management",
  },
  {
    targetPath: "/admin/report/daily-cash",
    title: "Report Management",
  },
  {
    targetPath: "/admin/report/srb",
    title: "Report Management",
  },
  {
    targetPath: "/admin/report/donation",
    title: "Report Management",
  },
  {
    targetPath: "/admin/report/other",
    title: "Report Management",
  },
];

export const breadcrumbs = [
  {
    targetPath: "/admin/facility",
    title: "Facilities",
    pageSetting: "Facility Management",
  },
  {
    targetPath: "/admin/facility/booking",
    title: "Bookings",
    pageSetting: "Facility Management",
  },

  {
    targetPath: "/admin/facility/schedule",
    title: "Schedule",
    pageSetting: "Facility Management",
  },
  {
    targetPath: "/admin/facility/booking-management",
    title: "Booking Management",
    pageSetting: "Facility Management",
  },
  {
    targetPath: "/admin/facility/addon-returns",
    title: "Addon Returns",
    pageSetting: "Facility Management",
  },

  {
    targetPath: "/admin/incomeCategory",
    title: "Income Categories",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/saleTaxes",
    title: "Sales Tax",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/tax-group",
    title: "Tax Group",
    pageSetting: "System Setting",
  },

  {
    targetPath: "/admin/wallet-request",
    title: "Wallet Request",
    pageSetting: "Load Amount",
  },
  {
    targetPath: "/admin/refund-request",
    title: "Wallet Refund",
    pageSetting: "Load Amount",
  },
  {
    targetPath: "/admin/memberships",
    title: "Memberships",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/credits",
    title: "Credits",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/products",
    title: "Products",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/roles",
    title: "Roles & Access Management",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/counter",
    title: "Counter Management",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/paymentMethods",
    title: "Payment Methods",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/categories",
    title: "Categories",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/system_configuration",
    title: "Configuration",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/business-unit",
    title: "Business Unit",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/pos/register",
    title: "Register",
    pageSetting: "Point of Sales",
  },
  {
    targetPath: "/admin/pos/cash",
    title: "Cash Management",
    pageSetting: "Point of Sales",
  },
  {
    targetPath: "/admin/pos/salesReport",
    title: "Sales Report",
    pageSetting: "Point of Sales",
  },
  {
    targetPath: "/admin/pos/sell/",
    title: "Sell",
    pageSetting: "Point of Sales",
  },
  {
    targetPath: "/admin/dh-accounting",
    title: "Payment Classification",
    pageSetting: "Account Management",
  },
  {
    targetPath: "/admin/hardware_integration",
    title: "Hardware Integration",
    pageSetting: "System Setting",
  },
  {
    targetPath: "/admin/members/detail",
    title: "Hardware Integration",
    pageSetting: "Member",
  },
  {
    targetPath: "/admin/check-in-logs",
    title: "Check In Logs",
    pageSetting: "Check In Details",
  },
  {
    targetPath: "/admin/event",
    title: "Event Management",
    pageSetting: "Event",
  },
  {
    targetPath: "/admin/report/sales",
    title: "Sales Report",
    pageSetting: "Report Management",
  },
  {
    targetPath: "/admin/report/daily-cash",
    title: "Daily Cash Report",
    pageSetting: "Report Management",
  },
  {
    targetPath: "/admin/report/payment",
    title: "Payment Report",
    pageSetting: "Report Management",
  },
  {
    targetPath: "/admin/report/revenue",
    title: "Revenue Report",
    pageSetting: "Report Management",
  },
  {
    targetPath: "/admin/report/srb",
    title: "SRB Report",
    pageSetting: "Report Management",
  },
  {
    targetPath: "/admin/report/donation",
    title: "Donation Report",
    pageSetting: "Report Management",
  },
  {
    targetPath: "/admin/report/other",
    title: "Other Report",
    pageSetting: "Report Management",
  }

];
